const CLAIM_VOUCHER_URL = `${process.env.API_V4_HOST}/promos/coupons/claims`;

export const postClaimVoucher = $axios => $axios.$post(CLAIM_VOUCHER_URL);
